<div class="kt-portlet">
  <div class="kt-portlet__head">
    <div class="kt-portlet__head-label">
      <span class="kt-portlet__head-icon">
        <i class="fas fa-chart-line"></i>
      </span>
      <h3 class="kt-portlet__head-title">Adjustment Entries</h3>
    </div>
    <div class="kt-portlet__head-toolbar">
      <button
        class="btn btn-secondary"
        type="button"
        [routerLink]="['/inventory/adjustment-entries/create']"
      >
        <i class="fas fa-industry"></i> New Inventory Adjustment Entry
      </button>
    </div>
  </div>

  <kt-portlet-body>
    <div class="toolbar">
      <div class="kt-widget filter">
        <div class="form-group">
          <label for="">SKU</label>
          <input
            type="text"
            class="form-control w300"
            placeholder="Enter SKU"
            [(ngModel)]="filter.sku"
            (keyup.enter)="getRecords(false, 1)"
          />
        </div>
        <div class="form-group">
          <br />
          <button
            class="btn btn-outline-info btn-sm btn-reset"
            (click)="resetFilters()"
          >
            <i class="fas fa-eraser"></i> Reset Filters
          </button>
        </div>
      </div>
    </div>

    <div class="overflow-auto result">
      <table class="table table-striped">
        <thead>
          <tr>
            <th>Posted Date</th>
            <th>Total Items</th>
            <th>Posted By</th>
            <th>Remarks</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="loading">
            <td colspan="10" class="text-center">
              <br />
              <h6 [translate]="'GENERAL.GETTING_RECORDS'">
                <i class="fas fa-spinner fa-spin"></i> Getting records...
              </h6>
              <br />
            </td>
          </tr>

          <tr *ngFor="let adj of records.data; let i = index">
            <td>
              {{ adj.created_at | date: 'mediumDate' }}
            </td>
            <td>
              {{ adj.item_count }} ITEMS
              <button
                class="btn btn-secondary btn-sm mr-2"
                (click)="adj.showItems = !adj.showItems"
              >
                <i class="fas fa-plus" *ngIf="!adj.showItems"></i>
                <i class="fas fa-minus" *ngIf="adj.showItems"></i>
              </button>
              <table class="table table-striped" *ngIf="adj.showItems">
                <thead>
                  <tr>
                    <th>SKU</th>
                    <th>Warehouse</th>
                    <th>Location</th>
                    <th>Qty Incoming</th>
                    <th>Qty Onhand</th>
                    <th>Qty Pending</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let dtl of adj.adjusted_stocks">
                    <td>
                      <a [routerLink]="['/inventory', dtl.rfq_id, 'view']">{{
                        dtl.sku
                      }}</a>
                    </td>
                    <td>
                      {{ dtl.warehouse ? dtl.warehouse.location_name : 'GENERAL' }}
                    </td>
                    <td>
                      <cnc-picklist-location
                        [pickingLocation]="dtl.location.is_pick_location"
                      ></cnc-picklist-location>
                      {{ dtl.location ? dtl.location.location_name : 'GENERAL' }}
                    </td>
                    <td>
                      {{ dtl.qty_incoming | decimalPlaces }}
                      <i>{{ dtl?.adjusted_unit_of_measure?.name }}</i>
                    </td>
                    <td>
                      {{ dtl.qty_onhand | decimalPlaces }}
                      <i>{{ dtl?.adjusted_unit_of_measure?.name }}</i>
                    </td>
                    <td>
                      {{ dtl.qty_pending | decimalPlaces }}
                      <i>{{ dtl?.adjusted_unit_of_measure?.name }}</i>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
            <td>
              {{ adj.user?.firstname || adj.user?.lastname ? (adj.user?.firstname || '') + ' ' + (adj.user?.lastname || '') : '' }}
            </td>
            <td>
              {{ adj.remarks }}
            </td>
          </tr>
        </tbody>
      </table>

      <mat-paginator
        [length]="records.total"
        [pageSize]="records.per_page"
        [pageIndex]="params.page - 1"
        [pageSizeOptions]="pageSizeOptions"
        (page)="getRecords($event)"
      >
      </mat-paginator>
    </div>
  </kt-portlet-body>
</div>
